import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

import { cellVariants, headerVariants, headVariants } from '@/components/machine/MachineTable';

interface MachineTableHeaderProps {
  isSelected: boolean;
  hasPrice: boolean;
}

export const MachineTableHeader = ({ isSelected, hasPrice }: MachineTableHeaderProps) => {
  const { t } = useTranslation();
  return (
    <TableHeader className={headerVariants({ isSelected })}>
      <TableRow className="border-none bg-transparent hover:bg-transparent">
        <TableHead className={cn(headVariants({ isSelected }), cellVariants({ title: true }))}>
          {t('machine.title')}
        </TableHead>
        <TableHead className={cn(headVariants({ isSelected }), cellVariants({ ident: true }))}>
          {t('machine.ident')}
        </TableHead>
        <TableHead className={cn(headVariants({ isSelected }), cellVariants({ width: true }))}>
          {t('machine.workingWidth')}
        </TableHead>
        <TableHead className={cn(headVariants({ isSelected }), cellVariants({ weight: true }))}>
          {t('machine.weight')}
        </TableHead>
        <TableHead className={cn(headVariants({ isSelected }), cellVariants({ power: true }))}>
          {t('machine.power')}
        </TableHead>
        {hasPrice ? (
          <TableHead className={cn(headVariants({ isSelected }), cellVariants({ price: true }))}>
            {t('machine.listPriceWithoutVat')}
          </TableHead>
        ) : (
          <TableHead className={cn(headVariants({ isSelected }), cellVariants({ action: true }))}>
            &nbsp;
          </TableHead>
        )}
      </TableRow>
    </TableHeader>
  );
};
